<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('moneyClaim.details.fullLink') }}</label></td>
      <td>
        <router-link :to="selfLinkUrl">{{ fullLinkUrl }}</router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('moneyClaim.details.account_id') }}</label></td>
      <td>{{ details.account_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('moneyClaim.details.description') }}</label></td>
      <td>
        <description-or-link :description="details.description"/>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('moneyClaim.details.amount') }}</label></td>
      <td>{{ details.amount | price }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('moneyClaim.details.refunded_at') }}</label></td>
      <td><span v-if="details.refunded_at">{{ details.refunded_at | dateOnly }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('moneyClaim.details.cancelReason') }}</label></td>
      <td>{{ details.cancel_reason != 'unknown'? details.cancel_reason: ''}}</td>
    </tr>
    <tr>
      <td><label>{{ $t('moneyClaim.details.cancelDescription') }}</label></td>
      <td>{{ details.cancel_description }}</td>
    </tr>
  </table>
</template>
<script>
  import DescriptionOrLink from "src/components/Description/DescriptionOrLink"
  import linkUtils from "@/util/link_utils"

  export default {
    name: 'moneyClaimDetails',
    components: {
      DescriptionOrLink,
    },
    props: {
      details: {
        type: Object,
        required: true,
      },
    },
    computed: {
      selfLinkUrl() {
        return linkUtils.accountMoneyClaimsDetailsPath(this.$router, {account_id: this.details.account_id, money_claim_id: this.details.id})
      },
      fullLinkUrl() {
        return linkUtils.fullLinkUrl(this.selfLinkUrl)
      }
    }
  };
</script>
<style></style>
